import script from "./OrderGroupMenuDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderGroupMenuDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./OrderGroupMenuDropdown.vue?vue&type=style&index=0&id=8ec1e038&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ec1e038"]])

export default __exports__